import React from 'react';
import PropTypes from 'prop-types';

export default function HabiLogo({ size, dataId, width, className }) {
  const sizes = {
    XS: 30,
    S: 36,
    M: 54,
    L: 64,
  };
  const styles = {
    container: {
      fontStyle: 'normal',
      lineHeight: '1em',
      width: '1em',
      height: '1em',
      fontSize: `${sizes[size] || width}px`,
    },
    svg: {
      width: '1em',
      height: '1em',
    },
  };
  return (
    <i
      style={styles.container}
      data-id={dataId}
      className={className}
      aria-label='logo de habi.co'
    >
      <svg
        style={styles.svg}
        viewBox='0 0 60 56'
        alt='Logo de Habi'
        title='Logo de Habi'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M59.3334 29.1375V47.1706C59.3334 51.8634 55.5458 55.651 50.8669 55.651H9.14717C4.45439 55.651 0.666748 51.8495 0.666748 47.1706V29.1375C0.666748 26.8538 1.58581 24.6676 3.22898 23.0662L24.0889 2.73546C27.3752 -0.467322 32.625 -0.467322 35.9113 2.73546L56.7712 23.0662C58.4144 24.6676 59.3334 26.8538 59.3334 29.1375ZM12.6565 30.3344V35.612C13.3666 34.693 14.1464 34.3031 15.344 34.3031C17.3771 34.3031 19.2987 35.6259 19.2987 39.0098V44.5937H15.5668V39.0237C15.525 37.8818 14.9541 37.5337 14.2021 37.5337C13.4641 37.5337 12.6565 38.0907 12.6286 39.2604V44.5798H8.85488V30.3344H12.6565ZM28.8372 34.5396H32.3603V44.6075H28.8929L28.7258 43.5213C27.8625 44.4961 26.5257 44.8442 25.3977 44.7885C22.4456 44.6075 20.7885 42.5048 20.7885 39.5666C20.7885 36.5866 22.7519 34.3028 25.6762 34.3028C27.1105 34.3028 28.0992 34.7902 28.6284 35.6118L28.8372 34.5396ZM24.5344 39.5666C24.5344 40.973 25.4256 41.7667 26.5535 41.7667C27.8207 41.7667 28.6284 40.7502 28.6284 39.5666C28.6284 38.2158 27.8764 37.3385 26.5535 37.3385C25.4395 37.3525 24.5344 38.1601 24.5344 39.5666ZM41.1186 34.3032C39.8236 34.3032 38.8767 34.7209 38.3197 35.3893H38.3058V30.3345H34.5599V44.6078H37.9019L38.069 43.5216C38.9324 44.4964 40.2692 44.8445 41.3971 44.7888C44.3493 44.6078 46.0064 42.7418 46.0064 39.5669C46.0064 36.4894 44.0568 34.3032 41.1186 34.3032ZM40.2553 41.781C38.9881 41.781 38.2361 40.7366 38.2361 39.6783C38.2361 38.4529 38.9324 37.3528 40.2553 37.3528C41.3832 37.3528 42.2744 38.1743 42.2744 39.5808C42.2744 40.9872 41.3832 41.781 40.2553 41.781ZM51.4528 44.6081V34.6935H47.6791V44.6081H51.4528Z'
          fill='#6A06FA'
        />
        <path
          d='M49.6277 11.6195C51.1812 11.6195 52.4406 10.3602 52.4406 8.80666C52.4406 7.25314 51.1812 5.99377 49.6277 5.99377C48.0742 5.99377 46.8148 7.25314 46.8148 8.80666C46.8148 10.3602 48.0742 11.6195 49.6277 11.6195Z'
          fill='#FF5958'
        />
      </svg>
    </i>
  );
}

HabiLogo.propTypes = {
  size: PropTypes.oneOf(['XS', 'S', 'M', 'L', '']),
  dataId: PropTypes.string,
  width: PropTypes.number,
  className: PropTypes.string,
};

HabiLogo.defaultProps = {
  size: '',
  dataId: '',
  width: null,
  className: '',
};
